module.exports = __webpack_public_path__ + "img/mercado_pago.d1b7464d.png";